import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '@prisjakt/ui-base';
import ProductCard from '@prisjakt/ui-product-card';
import ProductImage from '@prisjakt/ui-product-image';

export const RelatedProductList = styled.section`
  display: flex;
  flex-wrap: wrap;
`;

export const RelatedProductCard = styled(ProductCard)`
  && {
    min-width: 148px;
    flex: 1 0 50%;
    ${media.mediumOnly`
      flex: 1 0 33%;
    `};
    ${media.largeUp`
      flex: 1 0 15%;
    `};
  }
`;

export const RelatedProductImage = styled(ProductImage)`
  max-width: 100%;
`;

export const CompareLink = styled(Link)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
